import React from 'react'
import { func, object, string } from 'prop-types'
import Modal from '../Modal/Modal'
import { BtnGhost, BtnOrange, BtnPrimary } from '../ui/buttons'
import {
  OFFERS_BY_REASON,
  PROBLEMAS_GENERIC_OFFER,
  SUB_PADRAO,
  TITULO_PADRAO
} from './cancel-flow-config'
import {
  OffersFooter,
  OffersList,
  Offer,
  OfferIcon,
  OfferBody,
  OfferTitle,
  OfferText,
  OfferListaTitulo,
  OfferLista
} from './cancel-flow-styles'

function escaparRegex( texto ) {
  return texto.replace( /[$()*+.?[\\\]^{|}]/gu, '\\$&' )
}

function comDestaques( texto, destaques ) {
  const lista = [].concat( destaques || [] ).filter( Boolean )
  if ( !lista.length ) {
    return texto
  }
  const padrao = new RegExp( `(${lista.map( escaparRegex ).join( '|' )})`, 'gu' )
  return texto.split( padrao ).map( ( parte, indice ) => {
    const chave = `${indice}-${parte}`
    return lista.includes( parte )
      ? <b key={ chave }>{ parte }</b>
      : <React.Fragment key={ chave }>{ parte }</React.Fragment>
  } )
}

export default function CancelOffers( { sub, reason, submotivo, onClose, onBack, onContinue, onConversar, onAddress } ) {
  const problemaEntrega = reason === 'PROBLEMAS_ASSINATURA' && submotivo === 'E'
  const offer = reason === 'PROBLEMAS_ASSINATURA' && !problemaEntrega
    ? PROBLEMAS_GENERIC_OFFER
    : OFFERS_BY_REASON[ reason ] || OFFERS_BY_REASON.outro
  const OfferIco = offer.Icon
  const itensLista = offer.lista || []
  const paragrafos = offer.paragrafos || []
  const titulo = offer.titulo || TITULO_PADRAO
  const subtitulo = ( offer.sub || SUB_PADRAO ).replace( '{tenure}', sub.tenureText )

  const footer = (
    <OffersFooter>
      <BtnGhost
        onClick={ onBack }
        type="button"
      >Voltar
      </BtnGhost>
      <BtnPrimary
        onClick={ onConversar }
        type="button"
      >Tirar dúvidas com o Bookster
      </BtnPrimary>
      <BtnOrange
        onClick={ onContinue }
        type="button"
      >Quero cancelar mesmo assim
      </BtnOrange>
    </OffersFooter>
  )

  return (
    <Modal
      eyebrow="Cancelar renovação"
      footer={ footer }
      onClose={ onClose }
      steps={{ 'cur': 1 }}
      sub={ subtitulo }
      title={ titulo }
      wide
    >
      <OffersList>
        <Offer>
          <OfferIcon>
            <OfferIco
              height="22"
              width="22"
            />
          </OfferIcon>
          <OfferBody>
            { offer.h ? <OfferTitle>{ offer.h }</OfferTitle> : null }
            { offer.p ? <OfferText>{ comDestaques( offer.p, offer.pDestaque ) }</OfferText> : null }
            { paragrafos.map( ( paragrafo ) => (
              <OfferText key={ paragrafo.texto }>
                { comDestaques( paragrafo.texto, paragrafo.destaques ) }
              </OfferText>
            ) ) }
            { itensLista.length ? (
              <>
                { offer.listaTitulo ? <OfferListaTitulo>{ offer.listaTitulo }</OfferListaTitulo> : null }
                <OfferLista>
                  { itensLista.map( ( item ) => <li key={ item }>{ item }</li> ) }
                </OfferLista>
              </>
            ) : null }
            { problemaEntrega ? (
              <div>
                <BtnOrange
                  onClick={ onAddress }
                  type="button"
                >Atualizar endereço
                </BtnOrange>
              </div>
            ) : null }
          </OfferBody>
        </Offer>
      </OffersList>
    </Modal>
  )
}

CancelOffers.propTypes = {
  'sub': object.isRequired,
  'reason': string.isRequired,
  'submotivo': string,
  'onClose': func.isRequired,
  'onBack': func.isRequired,
  'onContinue': func.isRequired,
  'onConversar': func.isRequired,
  'onAddress': func
}

CancelOffers.defaultProps = {
  'submotivo': null,
  'onAddress': null
}
